import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=3e2d4a42&scoped=true&"
import script from "./HomeNew.vue?vue&type=script&lang=ts&"
export * from "./HomeNew.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=3e2d4a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d4a42",
  null
  
)

export default component.exports